export default "__VITE_ASSET__YUNWV5RP__"